import styled from 'styled-components';

// Enhanced warning container with elegant design
export const WarningContainer = styled.div`
  width: 90%;
  max-width: 600px;
  padding: 14px;
  margin: 20px auto;
  border-radius: var(--border-radius-lg, 12px);
  background: linear-gradient(135deg, #f7e3e3 0%, #f6dcdc 100%);
  border: 1px solid #ffcaca;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.08);

  display: flex;
  align-items: flex-start;
  gap: 16px;

  /* Smooth transitions for interactive states */
  transition: all 0.3s ease;

  &:hover {
    border-color: #ffb3b3;
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.12);
  }
`;

// Icon wrapper - circular badge
export const WarningIcon = styled.div`
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  background: #f4bfbf;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #d32f2f;
  font-weight: 600;
`;

// Content wrapper for text
export const WarningContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

// Heading for the warning title
export const WarningTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #c41c3b;
  letter-spacing: 0.3px;
`;

// Body text for the warning message
export const WarningMessage = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #d32f2f;
  line-height: 1.6;
  letter-spacing: 0.2px;
`;

// Example component usage
export const WarningCard = ({ title, message, icon = '⚠️' }) => {
  return (
    <WarningContainer>
      <WarningIcon>{icon}</WarningIcon>
      <WarningContent>
        {title && <WarningTitle>{title}</WarningTitle>}
        <WarningMessage>{message}</WarningMessage>
      </WarningContent>
    </WarningContainer>
  );
};

export default WarningCard;
